'use client';

import { Button } from '@petsmart-ui/sparky';
import Link from 'next/link';

import { trackHelpSectionClick } from './analytics';

type HelpContactUsLinkProps = {
    pageName: string;
};

const TARGET_SELF = '_self';

export default function HelpContactUsLink({ pageName }: Readonly<HelpContactUsLinkProps>) {
    return (
        <Link
            target={TARGET_SELF}
            href="/account/contact"
            rel="noreferrer"
            onClick={() => trackHelpSectionClick(pageName, 'contact us')}
        >
            <Button className="help-cta" variant="primary" text="Contact us" fullWidth={false} size="lg" />
        </Link>
    );
}
